import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'

export default class Navigation extends Component {

   constructor(props) {
    super(props)

    this.state = {
      selectedLink: this.props.location.pathname,
      sideBarOpen: false
    }

    browserHistory.listen( location =>  {
     this.setState({
      selectedLink: location.pathname,
     })
    })
  }

  renderLinks(activeLink) {
    const titles = new Map()

    titles.set('/', 'App')
    titles.set('/features', 'Features')
    titles.set('/waitlist', 'Waitlist')

    return [this.props.router.routes[0]].concat(this.props.router.routes[0].childRoutes).map((route, i) => {
      const {path} = route
      const title = titles.get(path)

      return (
        <Link to={path} key={i}>
          <button className={path === activeLink ? 'inverted' : ''}>{title}</button>
        </Link>
      )
    })
  }

  render() {
    const { selectedLink } = this.state
    return (
      <nav>
        {this.renderLinks(selectedLink)}
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation.js